import { Component } from '@angular/core';

@Component({
  selector: 'app-consumidor',
  templateUrl: './consumidor.component.html',
  styleUrls: ['./consumidor.component.css']
})
export class ConsumidorComponent {
}



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor.component.ts